<template>

    <div class="bt--notes-main">

        <div class="image-pilot">
            <img :src="getSvgStreamUrl" @error="errorsvg(0)" @load="errorsvg(1)" onerror="this.style.display='none'" alt="svg">
        </div>
        <div>
            <p v-if="!Svgshow"> Svg file couldn't get...</p>
        </div>

        <div class="field">
            <p class="heading is-size-6 has-text-centered">Clearance Pilot Input</p>
        </div>

        <div class="photo-pilot">

                <div class="content">
                    <img :src="getJpegStreamUrl" @error="errorjpeg(0)" @load="errorjpeg(1)" onerror="this.style.display='none'" alt="Additional Info 2" width="100%" height="100%">
                </div>
                <div>
                    <p v-if="!Jpegshow"> Jpg file couldn't get...</p>
                </div>

                <div class="field">
                    <p class="heading is-size-6 has-text-centered">Notes Pilot Photo</p>
                </div>

                <div class="photo-pilot">
                    <h2 style="font-size: 1.5rem; margin-left: 40px; margin-bottom: 20px">Notes</h2>
                    <textarea name="clearence-text" id="" cols="20" rows="14" class="textarea" v-if="InputsObject.BTO.notesText" v-model="InputsObject.BTO.notesText" readonly></textarea>
                </div>

        </div>


    </div>

</template>

<script>

    import {createUrl} from "../../../../http";
    import {mapState} from "vuex";
    //import http from "../../../../http"

    export default {
        name: "Notes",
        props: ["id", "flight", "additionalCrew"],
        data(){

            return {
                getSvgStreamUrl : "",
                getJpegStreamUrl : "",
                activeJpegUrl : createUrl('/EffIpadPreview/GetInputJpeg/'),
                activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
                Jpegshow : true,
                Svgshow : true,
                activeJpegUrlTest : createUrl('/EffIpadPreview/GetInputJpegTaskTest/'),
                getJpegStreamUrlTest :"",

            }

        },

        async created()
        {

                this.getSvgStreamUrl = this.activeSvgUrl + this.id + "/" + this.flight.std + "/" + this.ActiveDevice_UID + "/" + "BTO_AtisNotes.svg"+"/"+this.flight.flightArchiveStat;

                this.getJpegStreamUrl = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" + this.ActiveDevice_UID + "/" + "BTO_AtisNotes.jpg"+"/"+this.flight.flightArchiveStat;

                // this.TestAs(this.id,this.flight.std,55);

                // var i;
                // for (i = 0; i < 500; i++) {
                //
                //      this.TestAs(this.id,this.flight.std,i);
                // }

        },

        methods: {

            errorsvg(stat)
            {
                if (stat ==0)
                {
                    this.Svgshow = false;
                }
                else if(stat ==1)
                {
                    this.Svgshow = true;
                }
            },

            errorjpeg(stat)
            {
                if (stat ==0)
                {
                    this.Jpegshow = false;
                }
                else if(stat ==1)
                {
                    this.Jpegshow = true;
                }
            }


            // async TestAs(id, std,i)
            // {
            //     //http.instance.get("/EffIpadPreview/GetInputJpegTaskTest/", {params: {FKey1: FKey1, STD : std, }});
            //
            //     var Data = http.instance.get("/EffIpadPreview/GetInputJpegTaskTest/",{
            //         params :
            //             {
            //                 KFZ : id,
            //                 STD : std,
            //                 JpegName : "BTO_AtisNotes.jpg",
            //                 ReqId : i
            //             }});
            //
            //     return  Data;
            //     //this.getJpegStreamUrlTest = this.activeJpegUrlTest + id + "/" + std + "/" + "BTO_AtisNotes.jpg" + "/"+ i;
            // },


        },

        computed: {

            ...mapState("ipadmain",["ActiveDevice_UID", "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

        },

        components : {


        }

    }
</script>

<style scoped>
.photo-pilot{
    margin-bottom: 25px;
}
</style>
